window.theme = window.theme || {};

theme.Collection = (function () {

    var selectors = {
        "productEntry": ".uk-card-product",
        "productGroup": ".card-group",
        "grid": "#products-grid"
    };

    function Collection(container) {

        var $container = (this.$container = Util.$(container));
        this.$grid = Util.$(selectors.grid, $container);
        this.$productEntries = Util.$$(selectors.productEntry, this.$grid);
        this.breakpoint = 992,
	    // Utilities
        this._isSmallScreen = false,
        this._run();
    } 


    Collection.prototype = _.assignIn({}, Collection.prototype, {

        _run: function () {
            //this._initWishlistButtons();
            Util.on(window, 'load resize',  this._productSearchFilters.bind(this));
            Util.on(Util.$("#products-grid"), "click", '[data-btn-like]', this._onAddToWishList.bind(this));
        },


        _onAddToWishList: function(evt){

            evt.preventDefault();
            var productId = Util.data(evt.current, "product-id");

            var json = document.querySelector('[data-id="bc-product-json-' + productId + '"]').innerHTML; 
                product = JSON.parse(json); 
            var variant = product.variants[0];
            var image = variant.image ? variant.image : (product.images[0] ? product.images[0].src : null);
            var params = {};

			// Fetch variant ID from image URL
            variantId = variant.id ? variant.id : product.id
            
			params["epi"]  = parseInt(variantId);
			params["du"]   = window.theme.baseUrl + product.url;//window.theme.baseUrl + product.url;
			params["empi"] = parseInt(product.id);
			params["iu"]   = image;
			//params["pr"] = parseFloat(theme.Currency.formatMoney(variant.price, '{{amount}}')); 
			params["pr"]   = variant.price/100; 

			theme.Utility.addToWishList(params, function(){
			});
        },

    
        _productSearchFilters: function () {	

            /**
             * Bind and unbind modals according to the screen width
             */
            this._isSmallScreen = ((Util.width(window) < this.breakpoint) ? true : false);

            if (this._isSmallScreen) {
                UIkit.modal("#filter-box-mobile");
                UIkit.modal("#sort-box-mobile");
            } else {
                UIkit["modal"]("#filter-box-mobile").$destroy();
                UIkit["modal"]("#sort-box-mobile").$destroy();
    
                Util.removeClass(Util.$("#filter-box-mobile"), "uk-modal");
                Util.removeClass(Util.$("#sort-box-mobile"), "uk-modal");
            }
        }
    });
    return Collection;
})();